import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import {
  ApexAnnotations, ApexAxisChartSeries,
  ApexChart, ApexDataLabels, ApexFill, ApexLegend, ApexMarkers, ApexResponsive, ApexStroke, ApexTheme, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent
} from 'ng-apexcharts';
import { Subject } from 'rxjs';
import { HelperService } from '../helper.service';
import { CropType } from '../models/cropType';
import { Chart, Data, NdviChart, NdviSeries } from '../models/ndviChart';
import { PriorityGroup } from '../models/priorityGroup';
import { Ranking } from '../models/ranking';
import { Season } from '../models/season';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import _moment from 'moment';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import { default as _rollupMoment } from 'moment';
import { RankingsComponent } from '../rankings/rankings.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import { MappingService } from '../services/mapping.service';
import { Base } from '../services/base';


const moment = _rollupMoment || _moment;

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  yaxis: ApexYAxis;
  markers: ApexMarkers;
  fill: ApexFill;
  theme: ApexTheme;
  annotations: ApexAnnotations;
  responsive: ApexResponsive;
  redrawOnParentResize: Boolean;
  redrawOnWindowResize: Boolean;
};

@Component({
    selector: 'app-priority-groups',
    templateUrl: './priority-groups.component.html',
    styleUrls: ['./priority-groups.component.css'],
    animations: [
        trigger('slideInOut', [
            state('out', style({ "max-width": '25%' })),
            state('in', style({ "max-width": '1%' })),
            transition('out => in', [group([
                    animate('100ms ease-in-out', style({
                        "max-width": '1%'
                    }))
                ])]),
            transition('in => out', [
                animate('100ms ease-in-out', style({
                    "max-width": '25%'
                }))
            ])
        ]),
        trigger('rotate', [
            state('out', style({ transform: 'rotate(0deg)' })),
            state('in', style({ transform: 'rotate(180deg)' })),
            transition('out => in', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(0deg)'
                }))
            ]),
            transition('in => out', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(180deg)'
                }))
            ])
        ]),
        trigger('slideInOut1', [
            state('out', style({ "max-width": '65%' })),
            state('in', style({ "max-width": '99%' })),
            transition('out => in', [group([
                    animate('100ms ease-in-out', style({
                        "max-width": '99%'
                    }))
                ])]),
            transition('in => out', [
                animate('100ms ease-in-out', style({
                    "max-width": '65%'
                }))
            ])
        ]),
    ],
    standalone: false
})

export class PriorityGroupsComponent implements OnInit {

  public tenantId: number;
  cropType;

  cropTypeList: CropType[] = [];
  priorityGroups: PriorityGroup[] = [];
  filteredPriorities: PriorityGroup[] = [];
  rankings: Ranking[] = [];

  selectedPriority: any;

  public showPriority: boolean = true;

  activeId = -1;
  activeSeason: Season;
  activeSeasons: Season[] = [];
  seasonTitle = "";
  cropTitle = "";

  animationState = 'in';

  priorityWidth: number;

  colorScheme = {
    domain: ['#663333', '#0000CC', '#33CC00', '#330000', '#CC0000', '#993300', '#003300', '#FF6600', '#660000', '#333300', '#CC00CC', '#99CC33',
      '#009966', '#666633', '#CC0033', '#9900FF', '#006633', '#660066', '#336666', '#003333', '#339999', '#006699', '#3366FF', '#0099FF', '#333366',
      '#003399', '#330099', '#000066', '#0000CC', '#663333', '#0000CC', '#33CC00', '#330000', '#CC0000', '#993300', '#003300', '#FF6600', '#660000', '#333300', '#CC00CC', '#99CC33',
      '#009966', '#666633', '#CC0033', '#9900FF', '#006633', '#660066', '#336666', '#003333', '#339999', '#006699', '#3366FF', '#0099FF', '#333366',
      '#003399', '#330099', '#000066', '#0000CC']
  };

  ndviChartData: NdviChart[];
  initialNdviChartData: NdviChart[];
  ndviLineChart: Chart[];
  showImage: boolean = true;

  @ViewChild('div1') container: ElementRef;
  @ViewChild('con') con: ElementRef;

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(
    private _bottomSheet: MatBottomSheet,
    public base: Base,
    public mappingService: MappingService,
    public nav: NavBarComponent,
    private router: Router,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    public helper: HelperService,
    private renderer: Renderer2
  ) {

    this.nav.toggleLoading(false);

    this.chartOptions = {
      series: [],
      chart: {
        height: 100,
        toolbar: {
          offsetX: -230,
          offsetY: -5,
        },
        // height: '100%',
        // width: '1300',
        type: "line",
        // stackType: 'normal'
      },
      // annotations: {
      //   position: "front"
      // },
      legend: {
        show: true,
        position: 'right',
        horizontalAlign: 'left',
        offsetX: -50,
        offsetY: 0,
        width: 200,
        markers: {
          radius: 0,
        },
        itemMargin: {
          horizontal: 5,
          vertical: 5
        },
      },
      stroke: {
        curve: "straight",
        width: 1,
      },
      yaxis: {
        min: 0,
        max: 1,
        tooltip: {
          enabled: true
        },
      },
      xaxis: {
        type: "datetime",
        tooltip: {
          enabled: true
        },
        labels: {
          datetimeFormatter: {
            month: "MMM 'yy"
          }
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        x: {
          format: "MMMM"
        },
        //   y: {
        //     title: {
        //         formatter: (seriesName) => seriesName,
        //     },
        // },
        // inverseOrder: true,
        items: {
          display: 'flex',
        },
      },
      responsive: {
        breakpoint: 1000,
        options: {
          chart: {
            // height: 150,
            type: "line",
            zoom: {
              enabled: false
            },
            toolbar: {
              offsetX: -80,
              offsetY: -7,
            }
          }
        },
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true
    };

    this.nav.tenantId$.subscribe(id => {
      nav.toggleLoading(true);
      this.showImage = true;
      this.tenantId = id;
      this.ndviLineChart = [];

      if (this.animationState == 'in') {
        this.animationState = 'out';
      }

      this.mappingService.getActiveSeasons(this.tenantId).subscribe((activeSeasons) => {
        this.activeSeasons = [];
        this.priorityGroups = [];
        this.rankings = [];
        this.ndviChartData = [];
        this.initialNdviChartData = [];
        this.activeSeason = undefined;
        this.activeId = -1;
        activeSeasons.forEach(season => {
          if (season.active) {
            this.activeSeason = season;
            this.activeSeasons.push(season);
          }
        })
        if (this.activeSeason != null) {
          this.mappingService.getPriorityGroups(this.activeSeason.id).subscribe((priorityGroups) => {
            this.priorityGroups = priorityGroups;
            this.priorityGroups.sort((a, b) => a.endDate < b.startDate ? 1 : 0);
            for (let i = 0; i < this.cropTypeList.length; i++) {
              for (let j = 0; j < this.priorityGroups.length; j++) {
                if (this.cropTypeList[i].id == this.priorityGroups[j].cultivarId) {
                  this.priorityGroups[j].cultivarName = this.cropTypeList[i].name;
                }
              }
            }
            this.filteredPriorities = this.priorityGroups;
            if (priorityGroups.length > 0) {
              this.getRankings(priorityGroups[0], true);
            } else {
              this.openSnackBar(this.translate.instant("PRIORITY-GROUPS.NO-ACTIVE-SEASONS"), this.translate.instant("SNACKBAR.DISMISS"));
              nav.toggleLoading(false);
            }
          });
        } else {
          this.openSnackBar(this.translate.instant("PRIORITY-GROUPS.NO-ACTIVE-SEASONS"), this.translate.instant("SNACKBAR.DISMISS"));
          nav.toggleLoading(false);
        }
      });
    });

    this.mappingService.getCropTypes().subscribe((cropTypes) => {
      cropTypes = this.helper.getTranslationByName(cropTypes, "CROPS.");
      cropTypes.forEach(cropType => {
        var tmpCrops: CropType = {
          id: cropType.id,
          name: cropType.name
        }

        this.cropTypeList.push(tmpCrops);
      })
    })

    this.base.menuIsOpen$.subscribe((menu) => {
      window.dispatchEvent(new Event('resize'));
    })
  }

  public generateData(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  }

  findCropType(id: number) {
    let obj = this.cropTypeList.filter(item => item.id === id);
    return obj[0].name;
  }

  toggleGroups(width) {
    if (width > 50) {
      this.priorityWidth = width;
      this.showPriority = false;
    } else {
      this.showPriority = true;
    }
    this.animationState = this.animationState === 'out' ? 'in' : 'out';
    window.dispatchEvent(new Event('resize'));
  }

  getRankings(priorityGroup: PriorityGroup, tenantSwitch: boolean) {
    this.rankings = [];

    if (!tenantSwitch) {
       this.nav.toggleLoading(true);
    }
    this.activeId = priorityGroup.id;

    for (let i = 0; i < this.activeSeasons.length; i++) {
      if (this.activeSeasons[i].id == priorityGroup.seasonId) {
        this.seasonTitle = this.activeSeasons[i].description;
      }
    }
    for (let i = 0; i < this.cropTypeList.length; i++) {
      if (this.cropTypeList[i].id == priorityGroup.cultivarId) {
        this.cropTitle = this.cropTypeList[i].name;
      }
    }

    this.toggleGroups((this.container.nativeElement as HTMLElement).offsetWidth);

    this.mappingService.getRankings(priorityGroup.id, priorityGroup.calculationId).subscribe(rankings => {
      rankings.forEach(ranking => {
        this.rankings.push(ranking);
      })
      this.rankings.sort((a, b) => a.ranking - b.ranking);

      this.mappingService.getUncalculatedRankings(priorityGroup.id, priorityGroup.calculationId).subscribe(uncalculatedRankings => {
        uncalculatedRankings.forEach(ranking => {
          this.rankings.push(ranking);
        })
  
        this.processRankings(priorityGroup);
      })
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  processRankings(priorityGroup) {
    let todayDate = moment().format("YYYY-MM-DD");
    this.initialNdviChartData = [];
    let count = 0;
    let count$ = new Subject<number>();
    count$.next(0);

    this.rankings.forEach(ranking => {
      let startDate = moment(priorityGroup.startDate).format("YYYY-MM-DD");
      
      this.mappingService.getNdviChart(ranking.fieldId, startDate, todayDate).subscribe(ndviIndexes => {

        var seriesList: NdviSeries[] = [];
        var dataList: Data[] = [];

        ndviIndexes.forEach(ndviIndex => {
          var value = ndviIndex.mean;
          var val = ndviIndex.mean.toFixed(2);
          var newVal = Number(val);
          // var date = new Date(ndviIndex.lastModified);
          var date = moment(new Date(ndviIndex.lastModified)).format("YYYY-MM-DD");
          var newDate = date.toString();

          let tmpSeries: NdviSeries = {
            name: new Date(ndviIndex.lastModified),
            value: value
          };

          let tmpData: Data = {
            x: date,
            y: newVal
          }

          seriesList.push(tmpSeries);
          dataList.push(tmpData);
        });

        let ndviData: NdviChart = {
          name: ranking.fieldName,
          series: seriesList
        };

        let chartData: Chart = {
          name: ranking.fieldName,
          color: this.colorScheme.domain[count],
          data: dataList,
        };

        this.ndviLineChart.push(chartData);
        this.ndviChartData.push(ndviData);


        this.ndviLineChart.sort((a, b) => a.name.localeCompare(b.name));
        this.showImage = false;
      // }

        this.chartOptions = {
          series: this.ndviLineChart,
          chart: {
            toolbar: {
              offsetX: -230,
              offsetY: -5,
            },
            // chart height /////////////////////////
            height: '420px',
            // width: '100%',
            type: "line",
            // stackType: 'normal'
          },
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'left',
            offsetX: -50,
            offsetY: 0,
            width: 200,
            markers: {
              radius: 0,
            },
            itemMargin: {
              horizontal: 5,
              vertical: 5
            },
          },
          stroke: {
            curve: "straight",
            width: 1,
          },
          yaxis: {
            min: 0,
            max: 1,
            tooltip: {
              enabled: true
            },
          },
          xaxis: {
            type: "datetime",
            tooltip: {
              enabled: true
            },
            labels: {
              datetimeFormatter: {
                month: "MMM 'yy"
              }
            }
          },
          tooltip: {
            enabled: true,
            shared: true,
            x: {
              format: "MMMM"
            },
            //   y: {
            //     title: {
            //         formatter: (seriesName) => seriesName,
            //     },
            // },
            // inverseOrder: true,
            items: {
              display: 'flex',
            },
          },
          responsive: {
            breakpoint: 588,
            options: {
              chart: {
                // height: 150,
                type: "line",
                zoom: {
                  enabled: false
                },
                toolbar: {
                  offsetX: -80,
                  offsetY: -7,
                }
              }
            },
          },
          redrawOnParentResize: true,
          redrawOnWindowResize: true
        };

        count++;
        count$.next(count);
      });
      window.dispatchEvent(new Event('resize'));
    });


    count$.subscribe(count => {
      if (count === this.rankings.length) {
         this.nav.toggleLoading(false);
        this.ndviChartData = [...this.ndviChartData];
        this.initialNdviChartData = JSON.parse(JSON.stringify(this.ndviChartData));
      }
    })
  }

  getStatus(ranking: Ranking) {
    if (ranking.flagged) {
      return this.translate.instant("PRIORITY-GROUPS.RANKING-FLAGGED");
    } else {
      if (ranking.uncalculated) {
        return this.translate.instant("PRIORITY-GROUPS.RANKING-UNCALCULATED");
      } else {
        return this.translate.instant("PRIORITY-GROUPS.RANKING-IN-RANGE");
      }
    }
  }

  getIcon(ranking: Ranking) {
    if (ranking.flagged) {
      return "info";
    } else {
      if (ranking.uncalculated) {
        return "";
      } else {
        return "check";
      }
    }
  }

  getIconClass(ranking: Ranking) {
    if (ranking.flagged) {
      return "info";
    } else {
      if (ranking.uncalculated) {
        return "";
      } else {
        return "check";
      }
    }
  }

  getRankingIcon(ranking: Ranking) {
    if (ranking.ranking < ranking.previousRanking) {
      return "arrow_upward";
    } else if (ranking.ranking > ranking.previousRanking) {
      return "arrow_downward";
    }
  }

  formatTimeStamp(timestamp: string) {
    return moment.utc(timestamp).format("DD MMM YYYY");
  }

  isLegend = (event) => typeof event === 'string';

  isDataShown = (event) => {
    const selectedBar = this.ndviChartData.find(model => {
      return model.name === event && model.series[0].value !== 0;
    });

    return typeof selectedBar !== 'undefined';
  }

  openBottomSheet() {
    const bottomSheetRef = this._bottomSheet.open(RankingsComponent, {
      data: { rankings: this.rankings, activeSeason: this.seasonTitle, cropType: this.cropTitle }
    });
    bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {

    });
  }

  ngOnInit(): void {
  }

  onPrioritySearch(value) {
    this.selectedPriority = value;
    if (this.selectedPriority) {
      this.filteredPriorities = this.filteredPriorities.filter(
        item => item.cultivarName.toLowerCase().includes(this.selectedPriority.toLowerCase())
      );
    } else {
      this.filteredPriorities = this.priorityGroups;
    }
  }

  ngAfterViewChecked(): void {
    if (this.con) {
      let height = this.con.nativeElement.offsetHeight;
    }
  }
}
